import { render, staticRenderFns } from "./gj-tag-cascader.vue?vue&type=template&id=af283584&scoped=true&"
import script from "./gj-tag-cascader.vue?vue&type=script&lang=js&"
export * from "./gj-tag-cascader.vue?vue&type=script&lang=js&"
import style0 from "./gj-tag-cascader.vue?vue&type=style&index=0&id=af283584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af283584",
  null
  
)

export default component.exports